/* istanbul ignore file -- @preserve */

import createUploadLink from 'apollo-upload-client/createUploadLink.mjs';
import { bffAPILink } from 'bff';

function buildHttpLink() {
  return createUploadLink({
    uri: bffAPILink,
    credentials: 'include',
  });
}
export default buildHttpLink;
